export const coordenador_vigilancia_saude = {
  nome: 'Coordenador(a) de Vigilância em Saúde',
  id_perfil: 11,
  dashboard: [
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/aedes-aegypti/equipe/acs',
      titulo: 'Aedes aegypti',
      icone: false,
      imagem: '',
      svg: 'AedesAegypti',
      key: 'aedes_aegypti',
    },
    {
      link: '/oficinas-treinamentos',
      titulo: 'Oficinas Reuniões Treinamentos',
      icone: 'icofont-presentation',
      key: 'oficinas_treinamentos',
      featured: true,
    },
    {
      link: '/upa',
      titulo: 'UPA',
      icone: 'icofont-hospital',
      key: 'upa',
    },
    {
      link: '/saude-bucal',
      titulo: 'Saúde Bucal',
      icone: false,
      imagem: '',
      svg: 'IndicadoresEsb',
      key: 'saude_bucal',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/cidadao/painel',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
      // openNewTab: true,
      // callback: function (ctx, navigate) {
      //   const parceiro = ctx.$store.state?.infoMunicipio?.parceiro
      //   if (parceiro == null) {
      //     navigate(this.link, this.openNewTab)
      //   } else {
      //     ctx.$toast.error('Não disponível.', '', { position: 'topRight' })
      //   }
      // },
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  producao: [],
  vinculo_acompanhamento: [],
  bpa_e_ras: [],
  saude_bucal: [
    {
      link: '/lrpd',
      titulo: 'LRPD',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal_lrpd',
    },
    {
      link: '/sesb',
      titulo: 'SESB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal_sesb',
    },
  ],
  indicadores_esb: [],
  esf_eap: [],
  emulti: [],
  oficinas_treinamentos: [
    {
      link: '/oficinas-treinamentos-participante',
      titulo: 'Participante',
      icone: 'icofont-user',
      key: 'oficinas_treinamentos_participante',
    },
    {
      link: '/oficinas-treinamentos-certificados',
      titulo: 'Meus Certificados',
      icone: 'icofont-certificate',
      key: 'oficinas_treinamentos_certificados',
    },
  ],
  upa: [
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'upa_atendimentos_pessoa',
    },
  ],
}
